<template>
    <ResponsiveDialog :value="value" @input="$emit('input', $event)" :max-width="500" :header-title="$t('journey.oakNext.title')" header-class="skin-window-header--oak" card-class="skin-card">
        <div class="oak-dialog-bg skin-window--oak">
            <div class="oak-dialog-banner"/>
            <div class="oak-dialog-content">
                <OakTable :trainer-id="trainerId" @team-changed="$emit('team-changed')"/>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Popup nad City, ne fork celé obrazovky - nikdy nevolá visit-oak,
    // hráč zůstává v CITY (viz claude/components/journey-oak-league.md).
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
    import OakTable from './pieces/OakTable';

    export default {
        name: 'OakDialog',
        components: {ResponsiveDialog, OakTable},
        props: {
            value: {type: Boolean, default: false},
            trainerId: {type: Number, required: true},
        },
    }
</script>

<style scoped>
.oak-dialog-bg {
    flex: 1 1 auto;
    min-height: 0;
    /* pozadi (background) ridi skin (public/skins/normal.css,
       .skin-window--oak) - viz docs/superpowers/specs/2026-08-04-theme-
       skin-system-design.md */
    display: flex;
    flex-direction: column;
}
.oak-dialog-banner {
    flex: none;
    height: 130px;
    width: 80%;
    margin: 16px auto 0;
    border-radius: 16px;
    background-image: url('@/assets/pic/web/oak.png');
    background-size: cover;
    background-position: center;
    /* box-shadow ridi skin (public/skins/normal.css) */
}
.oak-dialog-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    /* rezerva pro plovoucí zavírací křížek (ResponsiveDialog) - 69px, stejná
       hodnota jako ostatní next/ popupy */
    padding: 16px 12px var(--responsive-dialog-close-clearance) 12px;
}
/* křížek se renderuje jen na mobilu (ResponsiveDialog), na desktopu je
   rezerva zbytečná - stejný breakpoint jako isMobileMixin */
@media (min-width: 960px) {
    .oak-dialog-content {
        padding-bottom: 16px;
    }
}
</style>
